<template>
  <div>
    <!--库存预警-->
    <header class="form-title">
      <Row>
        <Col span="16">
          <Form inline :label-width="80">
            <FormItem label="总件数:" style="margin-right: 30px">
              <strong class="result">{{result.totalNum}}</strong>
            </FormItem>
            <FormItem label="总金额:" style="margin-right: 30px">
              <strong class="result">{{result.totalMoney}}</strong>
            </FormItem>
            <FormItem label="总毛利:" style="margin-right: 30px">
              <strong class="result">{{result.totalBenefit}}</strong>
            </FormItem>
            <FormItem label="毛利率:" style="margin-right: 30px">
              <strong class="result">{{result.totalRateOfMargin}}</strong>
            </FormItem>
          </Form>
        </Col>
        <Col span="8" align="right">
          <Form inline :label-width="80">
            <FormItem label="选择时间">
              <DatePicker
                split-panels
                type="daterange"
                placeholder="选择日期"
                :options="options"
                @on-change="handleChange"
                :value="date"
              ></DatePicker>
            </FormItem>
          </Form>
        </Col>
      </Row>
    </header>
    <Form  inline  :label-width="80" >
      <FormItem label="店铺" v-if="isCustomerSharing==1">
        <Select v-model="searchshopName" filterable style="width: 200px">
          <Option
                  v-if="k.isCustomerSharing==1 || k.isgeneralwarehouse=='Y'"
                  :value="k.id"
                  v-for="(k,v) in shopList"
                  :key="v">{{k.name}}</Option>
        </Select>
      </FormItem>
    </Form>
    <Table stripe :columns="columns" :data="lists" :loading="loadingTable" class="tableList">
      <template slot-scope="{row,index}" slot="first">
        <Fy-Img class="img" :ImgSrc="row.goodsimg | filtImg(row.goodsimg)" :Width="50" :Height="50"></Fy-Img>
      </template>
    </Table>
    <div class="pageTotal">
      <Page :total="page.total" show-total :page-size="page.rows" @on-change="onGongPageTotal" />
    </div>
  </div>
</template>
<script>
import { Exp } from "@/util/Exp";
import FyImg from "../../components/Common/FyImg";
import expandRow from "../../components/Common/tableExpand";

export default {
  name: "customerAnalysis",
  components: {
    FyImg,
    expandRow
  },
  data() {
    return {
      cid: '',
      sid: '',
      options: {
        shortcuts: [
          {
            text: "昨日",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              return [start, start];
            }
          },
          {
            text: "今日",
            value() {
              const end = new Date();
              const start = new Date();
              return [start, end];
            }
          },
          {
            text: "近七日",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            }
          }
        ]
      },
      date: [Exp.getDays(-7), Exp.getDays(0)],
      formData: {
        cusId: "",
        sid:'',
        page: 1,
        rows: 10,
        beginTime: Exp.getDays(-7),
        endTime: Exp.getDays(0)
      },
      columns: [
        {
          width: 50,
          type: "expand",
          render: (h, params) => {
            return h(expandRow, {
              props: {
                row: params.row
              }
            });
          }
        },

        { title: "图片", key: "goodsimg", align: "center", slot: "first" },
        { title: "商品名称", key: "name", align: "center" },
        { title: "商品货号", key: "goodscode", align: "center" },
        // { title: "库存", key: "goodscode", align: "center" },
        { title: "总件数", key: "nums", align: "center" },
        { title: "总金额", key: "totalMoney", align: "center" },
        { title: "毛利", key: "benefit", align: "center" },
        { title: "毛利率", key: "rateOfMargin", align: "center" }
      ],
      result: {},
      lists: [],
      loadingTable: false,
      page: {
        total: 0,
        rows: 10
      },
      isCustomerSharing:0, //客户共享是否开启 0关 1开
      shopList: [],//店铺列表
      searchshopName: ''
    };
  },
  watch: {
    'searchshopName': {
      deep: true,
      handler: function (newVal, oldVal) {
        this.formData.sid = newVal
        this.getList()
      }
    },
  },

  created() {
    this.cid = JSON.parse(localStorage.getItem('shop')).cid
    //this.formData.sid = JSON.parse(localStorage.getItem('shop')).id
    this.formData.cusId = this.$route.query.cusId;
    this.isCustomerSharing = JSON.parse(localStorage.getItem('shop')).isCustomerSharing
    this.getList();
    this.getShopList()
  },
  methods: {
    //获取客户统计列表
    getList(widthOutTotal) {
      this.loadingTable = true;
      this.$Api.customerAnalysis(this.formData).then(res => {
        this.loadingTable = false;
        this.page.total = res.data.totalCount;
        this.lists = res.data.goods;
        if (widthOutTotal) return;
        this.getTotal();
      });
    },
    getTotal() {
      this.$Api
        .customerAnalysisTotal({
          sid:this.formData.sid,
          cusId: this.formData.cusId,
          beginTime: this.formData.beginTime,
          endTime: this.formData.endTime
        })
        .then(res => {
          this.result = res.data;
        });
    },
    // 日期改变
    handleChange(date) {
      if (date.length) {
        this.formData.beginTime = date[0];
        this.formData.endTime = date[1];
        this.getList();
      }
    },
    onGongPageTotal(num) {
      this.formData.page = num;
      this.getList(true);
    },
    //店铺列表
    getShopList() {
      var data = {
        cid: this.cid,
        page: 1,
        rows: 1000,
      };
      this.$Api.getShopList(data).then(res => {
        this.shopList = res.data;
        this.searchshopName = JSON.parse(localStorage.getItem('shop')).id
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.form-title {

  line-height: 54px;
  border-bottom: 1px solid #d9d9d9;
  margin-bottom: 20px;
}
.tableList .ivu-table-row td {
  padding: 10px 0;
  .img {
    display: block;
    margin: 10px auto;
  }
}
</style>